/* unplugin-vue-components disabled */import { render } from "./MyMessage.vue?vue&type=template&id=c3ca33e8&scoped=true"
import script from "./MyMessage.vue?vue&type=script&lang=js"
export * from "./MyMessage.vue?vue&type=script&lang=js"

import "./MyMessage.vue?vue&type=style&index=0&id=c3ca33e8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3ca33e8"]])

export default __exports__